import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "fwdRef", "spacing", "stacked", "visualizeRequiredFields"];
import React, { createContext, forwardRef } from 'react';
const allowedSpacings = ['default', 'small', 'large', 'hero'];
export const FormContext = /*#__PURE__*/createContext({
  spacing: 'default',
  stacked: false,
  visualizeRequiredFields: false
});

/**
 * _Form gathers information from users via different input controls that are paired with labels onto the rows of a form._
 *
 * ***
 *
 * `<Form>` is a wrapper component for [`<FormRow>`](#/Forms/FormRow) and [`<ButtonRow>`](#/Actions/ButtonRow)
 * components and it controls the layout of its children.
 *
 * On `xs` breakpoint a form will use a single-column stacked layout. On larger breakpoints a two-column layout is used by default.
 * Form can be forced to stacked layout on all breakpoints by setting `stacked` prop.
 *
 * Different `spacing` prop options control the density, i.e. sizes and spaces, of the layout.
 *
 * The component also sets whether the mandatory information is visually indicated or not.
 *
 * Additional props (including `ref`) will be forwarded to the wrapping `<form>` element.
 */
export const Form = _ref => {
  let {
      children,
      fwdRef,
      spacing: propSpacing,
      stacked = false,
      visualizeRequiredFields = false
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const propOrDefaultSpacing = propSpacing != null ? propSpacing : 'default';
  const spacing = allowedSpacings.includes(propOrDefaultSpacing) ? propOrDefaultSpacing : 'default';
  return /*#__PURE__*/React.createElement("form", _extends({}, props, {
    ref: fwdRef
  }), /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: {
      spacing,
      stacked,
      visualizeRequiredFields
    }
  }, children));
};
const Fwd = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(Form, _extends({}, props, {
  fwdRef: ref
})));
Fwd.displayName = 'Form';
export default Fwd;